var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide"}},[(_vm.RouterState)?_c('router-view'):_vm._e()],1),_c('input',{attrs:{"type":"hidden","name":"customServiceUrl","id":"customServiceUrl"},domProps:{"value":_vm.customServiceUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }